import React, { Fragment } from 'react';
import IncludedModifierTagButton from './IncludedModifierTagButton';
const IncludedModifierSection = function(props) {

    let included = [];
    let excluded = [];

    props.chosenIncluded.forEach((val, ind, arr) => {
        console.log(props.allModifiers)
        included.push(
            <IncludedModifierTagButton
                setFirstHalf={props.setFirstHalf}
                setSecondHalf={props.setSecondHalf}
                setWhole={props.setWhole}
                setExtra={props.setExtra}
                setLight={props.setLight}
                exclude={props.exclude}
                reAdd={props.reAdd}
                itemKey={val}
                key={ind}
                modifierObject={props.allModifiers[val]}
                isSelected={true}
                choices={props.choices}
                setNormal={props.setNormal}
                removeModifier={props.removeModifier}
                selectedMainItem={props.selectedMainItem}
                itemGroup={props.itemGroup}
            />)
    });

    props.excludedModifiers.forEach((val, ind, arr) => {
        excluded.push(<IncludedModifierTagButton exclude={props.exclude} reAdd={props.reAdd} itemKey={val} key={ind} modifierObject={props.allModifiers[val]} isSelected={false} choices={props.choices} removeModifier={props.removeModifier} />)
    });

    let shouldRender = props.excludedModifiers.length > 0 || props.chosenIncluded.length > 0;
    return shouldRender ? (
        <div className=''>
            {included.length > 0 ? <div>
                <h4 className='store-fg-primary text-left'>Included <small className="store-fg-primary">(no charge)</small></h4>
                <div className="container">
                    {included}
                </div>
            </div> : '' }
            {excluded.length > 0 ? (
                    <Fragment>
                        <h4 className='store-fg-primary text-left'>Removed</h4>
                        <div className={"container"}>
                         {excluded}
                        </div>
                    </Fragment>
                ) : ''}
            <hr className="store-bg-accent mt-4 mb-4" />

        </div>
    ) : '';
};
export default IncludedModifierSection;
